import {
  axiosHrClient,
  axiosReqCardClient,
  axiosReqCerClient,
  axiosNotiClient,
  axiosReqCardClient60s
} from '../plugins/axios'

export default {
  methods: {
    $setAxiosConfig(key, value) {
      return new Promise(resolve => {
        axiosHrClient.defaults.headers.common[key] = 'Bearer ' + value

        axiosReqCardClient.defaults.headers.common[key] = 'Bearer ' + value

        axiosReqCerClient.defaults.headers.common[key] = 'Bearer ' + value

        axiosNotiClient.defaults.headers.common[key] = 'Bearer ' + value

        axiosReqCardClient60s.defaults.headers.common[key] = 'Bearer ' + value
        // axiosReqCardClient.defaults.headers.common[key] = value

        resolve('Success!')
      })
    },

    async $linkPath(system, path, id) {
      //console.log(this.$guid)

      //console.log(system)

      //console.log(id)

      //console.log('path ' + path)

      //console.log('target ' + target)

      if (system === 'HR') {
        const paramList = path.split('/').map(p => {
          let res = ''

          if (p.startsWith(':')) {
            if (this.$isSelf && p === ':guid') {
              res = this.$guid_self
            } else {
              res = this['$' + p.replace(/:/g, '')]
            }
          } else {
            res = p
          }

          return res
        })

        if (paramList[1] === 'Assessment') {
          window.open(
            'https://hr.mis.cmu.ac.th' + paramList.join('/'),
            '_blank'
          )
        } else if (paramList[1] !== 'ReqEvent') {
          this.$router.push(paramList.join('/')).catch(() => {
            window.location = paramList.join('/')
          })
        } else {
          window.location.href =
            'https://hr.mis.cmu.ac.th' + paramList.join('/')
        }
      } else if (system === 'TORJA') {
        const paramList = path.split('/').map(p => {
          let res = ''

          if (p.startsWith(':')) {
            if (this.$isSelf && p === ':guid') {
              res = this.$guid_self
            } else {
              res = this['$' + p.replace(/:/g, '')]
            }
          } else {
            res = p
          }

          return res
        })

        window.open(
          'https://hr.mis.cmu.ac.th/' + paramList[1] + '/?emid=' + paramList[2],
          '_blank'
        )
      } else {
        // เปิด tab ทันทีใน user gesture เดียวกัน กัน Safari block popup
        const newTab = window.open('about:blank', '_blank')

        try {
          const externalPath = await axiosHrClient.post('/hrportal/pathpages', {
            ProgramItemMenuID: id,

            EmployeeID: this.$guid
          })

          if (
            externalPath.data.message &&
            externalPath.data.message === 'success'
          ) {
            if (newTab) {
              newTab.location.href = externalPath.data.data
            } else {
              // fallback: ผู้ใช้ block popup ทั้งหมด ให้เปลี่ยน tab ปัจจุบันแทน
              window.location.href = externalPath.data.data
            }
          } else {
            if (newTab) newTab.close()
            alert('no data')
          }
        } catch (e) {
          if (newTab) newTab.close()
          throw e
        }
      }
    }
  }
}
